// extracted by mini-css-extract-plugin
export default {"paginate":"Paginate_paginate__QzTaU","paginationBttns":"Paginate_paginationBttns__ZyMD7","paginationActive":"Paginate_paginationActive__4PtsS"};